<template>
	<el-dialog custom-class="map-dialog" :visible="show" append-to-body title="地图选点" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" @close="$emit('update:show', false)">
		<div class="toolbar">
			<div class="v-font-12 v-color-red">*点击地图添加点位</div>
			<div>
<!--				<el-cascader v-model="regionDataSelected" placeholder="选择省市区" style="width: 200px;margin-right: 5px" clearable filterable size="small" :options="regionData" :props="{value: 'label',label: 'label',expandTrigger: 'hover', checkStrictly: true}"></el-cascader>-->
<!--				<el-input v-model="address" placeholder="请输入检索地址" size="small" style="width:200px"></el-input>-->
        <el-autocomplete
          v-model="address"
          :trigger-on-focus="false"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
          placeholder="请输入地址关键字"
          style="width:250px"
          size="small"
        >
          <div class="suggest-row v-ellipsis" slot-scope="{ item }">
            <div class="name">{{ item.title }}</div>
            <div class="address v-font-12 v-color-gray">({{ item.address }})</div>
          </div>
        </el-autocomplete>
				<el-button type="primary" size="small" class="v-ml-10" @click="searchAddress">搜索</el-button>
			</div>
		</div>
		<div id="mapcontainer" style="width:100%;height:400px;position: relative"></div>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" type="primary" @click="doSubmit">确认选点</el-button>
		</div>
	</el-dialog>
</template>

<script>
	/* global BMapGL BMAP_STATUS_SUCCESS */
	import mapJs from '@/assets/js/map'
	import {regionData} from 'element-china-area-data';

	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			lng: {
				type: Number,
				default: 0
			},
			lat: {
				type: Number,
				default: 0
			},
			markerData: {
				type: Object,
				default: () => ({})
			}
		},

		data() {
			return {
				regionData,
				map: null,
				center: null,
				address: '',
				marker: null,
				lngLat: null,
				regionDataSelected: [],
				userInfo: this.$store.state.user.userInfo
			};
		},


		mounted() {
			this.loadMap();
			let {province, city, area} = this.userInfo.subjectInfo
			this.regionDataSelected = [province, city, area];
		},

		destroyed() {
			window.mapOnLoad = null;
			window.mapPluginOnLoaded = null;
		},

		methods: {

			async loadMap() {
				await this.utils.loadScript('https://api.map.baidu.com/api?type=webgl&v=3.0&ak=v796wkUHDbujL8YVa7Ntid7s2H3hDcHa&callback=mapOnLoad','mapOnLoad');
				this.initMap()
			},

			async initMap() {
				let map = this.map = new BMapGL.Map('mapcontainer');
				if (this.lng && this.lat) {
					let point = new BMapGL.Point(this.lng, this.lat)
					this.lngLat = {lng: this.lng, lat: this.lat};
					map.centerAndZoom(point, 16);
					this.addMarker(point)
				} else {
					let boundary = await this.getInitBoundary();
					let center = map.getViewport(boundary)
					map.centerAndZoom(center.center, center.zoom);
				}
				// map.setMapStyleV2({styleId: '1c12b94067ec6c5c4d4230d49d0e389d'});
				map.enableScrollWheelZoom();
				map.addEventListener('click', this.handleClickMap);
			},

			async getInitBoundary() {
				let {province, city, area} = this.userInfo.subjectInfo;
				let boundary = await this.getBoundary(`${province}${city}${area}`);
				return boundary
			},

			//行政区边界
			async getBoundary(address) {
				let storageBoundary = mapJs.getStorageBoundary('vyb_area_boundary', address);
				if (storageBoundary) {
					return storageBoundary.map(item => new BMapGL.Point(item.lng, item.lat));
				} else {
					let boundaryGD = await mapJs.getBoundary(address);
					let boundaryBD = mapJs.gaoToBaidu(boundaryGD);
					mapJs.setStorageBoundary('vyb_area_boundary', address, boundaryBD);
					return boundaryBD.map(item => new BMapGL.Point(item.lng, item.lat));
				}
			},


			handleClickMap(target) {
				if (!target.target.className.includes('BMap_mask')) {
					return
				}
				this.lngLat = target.latlng;
				if (this.marker) {
					this.marker.setPosition(target.latlng)
				} else {
					this.addMarker(target.latlng)
				}
			},

			addMarker(point) {
				this.marker = new BMapGL.Marker(point, {icon:null, enableDragging: true});
				this.map.addOverlay(this.marker);
				this.marker.addEventListener('dragend', (target) => {
					this.lngLat = target.latLng;
				})
			},


			querySearchAsync(queryString, cb){
				var options = {
					onSearchComplete: function(res){
						// 判断状态是否正确
						if (local.getStatus() == BMAP_STATUS_SUCCESS){
							// console.log(res)
							cb(res._pois);
						}
					}
				};
				var local = new BMapGL.LocalSearch(this.map, options);
				local.search(queryString);
      },

			handleSelect(row){
				this.map.centerAndZoom(row.point, 18);
      },

			//根据地址查询经纬度
			searchAddress() {
				var geocoder = new BMapGL.Geocoder();
				geocoder.getPoint(this.address, (point) => {
					if (point) {
						this.map.centerAndZoom(point, 18);
					} else {
						this.$message.error('地址查询失败');
					}
				},'杭州市')
			},

			doSubmit() {
				this.$emit('update:lng', this.lngLat.lng);
				this.$emit('update:lat', this.lngLat.lat);
				this.$emit('update:show', false);
			}


		}
	};
</script>

<style scoped>
	.toolbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 15px;
	}
.suggest-row .address{
  white-space: pre-wrap;
  line-height: 20px;
}
</style>
